"use client";

import Container from "@/components/ui/Container";
import Button from "@/components/ui/Button";
import { useEffect } from "react";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    // Structured log — picked up by Vercel Logs / Datadog / any JSON log aggregator.
    // When Sentry is installed, add: Sentry.captureException(error);
    const entry = {
      level: "error",
      message: "Client error boundary",
      service: "instanodes-web",
      timestamp: new Date().toISOString(),
      error: error.message,
      digest: error.digest,
      url: typeof window !== "undefined" ? window.location.href : undefined,
    };
    console.error(JSON.stringify(entry));
  }, [error]);

  return (
    <section className="section-pad relative overflow-hidden">
      <div aria-hidden className="bg-glow-hero pointer-events-none absolute inset-0 -z-10" />
      <Container>
        <div className="flex min-h-[50vh] flex-col items-center justify-center text-center">
          <h1 className="mb-4 text-4xl font-bold tracking-tight sm:text-5xl">
            Something went wrong
          </h1>
          <p className="mb-10 max-w-md text-lg leading-relaxed text-text-secondary">
            An unexpected error occurred. Our team has been notified. Try
            refreshing the page or head back home.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button onClick={reset} variant="primary">
              Try Again
            </Button>
            <Button href="/" variant="outline">
              Back to Home
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
